import { sendWebsocketMessage } from '../../../../../../../App';

export function modifyTarget(tradePlanId, tacticId, previousValue, newValue) {
  const msg = {
    messageType: 'updateTradePlan',
    tradePlanId,
    field: 'softOrder',
    value: {
      pluginId: tacticId,
      plugin: 'CANDLE_MAGNITUDE',
      details: { modifyTarget: { newValue }, previousValue },
    },

  };
  sendWebsocketMessage(msg);
}
